import {Calendar, Repeat, Clock, Download} from 'lucide-react'

export default function FeatureSection() {
  const features = [
    {
      icon: <Calendar className="w-8 h-8 text-teal-500" />,
      title: "8-6-7-7 Roster Calculator",
      description: "Specialized support for complex 8-6-7-7 rotation patterns commonly used in mining and FIFO operations."
    },
    {
      icon: <Repeat className="w-8 h-8 text-teal-500" />,
      title: "9-5 Roster Calculator",
      description: "Calculate 9 days on, 5 days off schedules popular in offshore and remote work industries."
    },
    {
      icon: <Clock className="w-8 h-8 text-teal-500" />,
      title: "Custom Rotation Patterns",
      description: "Create any rotation: 4 on 4 off, 2 on 2 off, or your own custom shift pattern for maximum flexibility."
    },
    {
      icon: <Download className="w-8 h-8 text-teal-500" />,
      title: "Export & Share",
      description: "Download your roster as PDF or Excel, or send a shareable link that opens the schedule for your whole team. No account needed to view it."
    }
  ]

  return (
    <section id="features" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Powerful Roster Planning Features
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Whether you need a shift roster calculator for standard patterns or complex rotations like 8-6-7-7, 
            our tool handles it all with professional accuracy.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-6 border border-slate-200 rounded-xl hover:shadow-xl hover:border-teal-400 transition-all duration-300"
            >
              <div className="mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
